import styles from "./UserChatMessage.module.css";
import { Container, Row, Col } from "react-bootstrap"
import 'bootstrap/dist/css/bootstrap.css';
interface Props {
    message: string;
    timestamp?: Date;
}

export const UserChatMessage = ({ message, timestamp }: Props) => {

    const formatDate = (date: Date) => {
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: 'Asia/Kolkata',
        };
        return new Intl.DateTimeFormat('en-IN', options).format(date);
    };

    const UserreceivedTime = timestamp || new Date();

    return (
        <div className={styles.container}>

            <div className={styles.message}>

                <div className={styles.UserTextQuery}>
                    {message}
                </div>

                <div className={styles.UserTextTimeStamp}>
                    {formatDate(UserreceivedTime)}
                </div>


            </div>
        </div>
    );
};
